import { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link, NavLink } from 'react-router-dom';
import { NexusMark } from '@/components/NexusMark';

const links = [
  { label: 'Platform', to: '/platform' },
  { label: 'For small MSPs', to: '/for-small-msps' },
  { label: 'Roadmap', to: '/roadmap' },
  { label: 'Blog', to: '/blog' },
  { label: 'Security', to: '/security' },
];

export function NavBar(): JSX.Element {
  const [open, setOpen] = useState(false);

  return (
    <AppBar
      position="sticky"
      elevation={0}
      className="border-b border-white/10 bg-nexus-bg/80 backdrop-blur-md backdrop-saturate-150"
    >
      <div className="container-content w-full">
        <Toolbar disableGutters className="h-[68px]">
          <Link to="/" className="flex flex-1 items-center gap-3 no-underline">
            <NexusMark size={30} />
            <div className="flex items-baseline gap-2">
              <span className="font-display text-xl font-semibold text-nexus-ink">Nexus</span>
              <Chip
                label="RMM · PSA"
                size="small"
                className="h-5 border border-nexus-purple/35 bg-nexus-purple/[0.18] text-[10.5px] font-bold tracking-wide text-nexus-purple-light"
              />
            </div>
          </Link>

          <div className="hidden items-center gap-8 md:flex">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `text-sm font-medium no-underline transition-colors hover:text-white ${
                    isActive ? 'text-white' : 'text-white/70'
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Button component={Link} to="/#notify" variant="outlined" size="small" className="border-white/15 normal-case">
              Join private preview
            </Button>
          </div>

          <IconButton
            aria-label="Open menu"
            onClick={() => setOpen(true)}
            className="text-white/80 md:hidden"
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </div>

      <Drawer
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
        PaperProps={{ className: 'w-[280px] border-l border-white/10 bg-nexus-bg' }}
      >
        <div className="flex items-center justify-between border-b border-white/10 px-5 py-4">
          <div className="flex items-center gap-2.5">
            <NexusMark size={24} />
            <span className="font-display text-lg font-semibold text-nexus-ink">Nexus</span>
          </div>
          <IconButton aria-label="Close menu" onClick={() => setOpen(false)} className="text-white/70">
            <CloseIcon />
          </IconButton>
        </div>
        <div className="flex flex-col gap-1 px-3 py-4">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `rounded-lg px-3 py-3 text-[15px] font-medium no-underline transition-colors ${
                  isActive ? 'bg-white/[0.06] text-white' : 'text-white/70 hover:bg-white/[0.04] hover:text-white'
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Button
            component={Link}
            to="/#notify"
            onClick={() => setOpen(false)}
            variant="contained"
            className="mt-3 normal-case"
          >
            Join private preview
          </Button>
        </div>
      </Drawer>
    </AppBar>
  );
}
